/* saikrishna 11/15/2022 2701135832 Added Basic Info fields and created this component
madhu 11/17/2022 2701135832 Integrated save api
Ashraf 11/18/2022 2701135832 fetching basic info data
Ashraf 11/19/2022 2701135832 resetting field list code on submit
Ashraf 11/21/2022 2701135832 resetting field list data on return to basic info
Ashraf 11/23/2022 2701135832 added override popup for basic info.
Prakash 11/23/2022  2701135832  Fixed Validation Alignments.
akhila 11/29/2022 2701135832 fixed toast issue
Lalitha 30/11/2022 2701135832  Added validation on code
Sai maheshwar 11/30/2022 2701135832 fixed basic infor submit issue
kavya9reddy 11/30/2022 2701135832 Added the Suggestions for formula code and formula name
Sohel 12/01/2022 2701135832 Added Override Type in payload.
Lalitha 12/08/2022 2701135832 Rename Formula to Data Calculation
Poornima 12/09/2022 3031450488 toast message changes
Saikrishna 12/09/2022 3031450488 save and stay in page functionality added.
Rajesh 12/09/2022 3031450488 download toast issue
akhila 12/12/2022 3031450488 changed Data calculation type options
akhila 12/12/2022 2701135832 fixed isDraft issue
Sohel 12/13/2022 2701135832 conditionally hide Save Button
kavyareddy 12/15/2022 2701135832 Added role disable condition
Ashraf 15/16/2022 2701135832 fixed role access
Raghu 12/18/2022 2701135832 Buttons spacing fixes
akhila 12/18/2022 2701135832 Added unSaved change popup
akhila 12/19/2022 2701135832 resetting field list
akhila 12/20/2022 2701135832 fixed isDraft issue
Dilip 12/20/2022 2701135832 Added return type dropdown data from API
akhila 12/21/2022 2701135832 integrated lookup api for returnType dropDown
akhila 12/23/2022 2701135832 fixed dataCalculation code uppercase issue
akhila 12/23/2022 2701135832 added category field validation
akhila 12/26/2022 2701135832 fixed category validation conditionally
Ashraf 01/02/2022 2701135832 renamed usage header title
Raghu 01/03/2022 2701135832 fixed alignment issue in category
Lalitha 01/05/2023 2701135832 fixed download configuration issue
Lalitha 01/10/2023 2701135832 fixed download configuration issue
Akhila 01/17/2023 2701135832 fixed aestric and validation issue in return type field
sai krishna 01/18/2023 2701135832 category field issue
Akhila 01/20/2023 2701135832 validation rename bug fix
manikanta 02/01/2023 2700912712 fixed Description
manikanta 02/01/2023 2700912712 fixed prefix issue
Ravi 02/20/2023 2700912712 fixed validation issue in code
Raghu 02/21/2023 2700912712 changed text feilds colors
Raghu02/23/2023 2700912712 fixed new ui changes
Raghu 02/28/2023 2700912712 added new class dor buttons
sohel 03/06/2023 2700912712 Added validation message for existing value
Sohel 06/20/2023 2700912712 Enabled Save Button
Akhila 06/21/2023 2700912712 conditionally disable save and finish button on submission
Gireesh 12/11/2023 2700912712 Added Data Calculation Code validation and description 
Gireesh 12/11/2023 2700912712 removed uppercase for Data Calculation Code validation in payload
Gireesh 12/12/2023 2700912712 Renamed Data Calculation Code to name
*/
import {Button, TextField, FormHelperText, FormControl, MenuItem} from '@material-ui/core';
import React, {useState, useEffect, useRef, useContext} from 'react';
import * as Yup from 'yup';
import {
  ResetAddRule as resetAddRule,
  fetchAllCodeAndDisplayName,
  fetchRuleGroup,
  resetFormula,
  resetRuleGroupPrintStatus,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {getBaseCategory, resetData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {Formik} from 'formik';
import {
  postBasicInfo,
  setReduxState,
  resetMessage,
  ResetMessage as resetMsg,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import OverrideRule from '../../../../../components/OverrideRule';
import {
  resetPrintUsageData,
} from './../../../../../redux/reducers/printUsage/index';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {RETURN_TYPE} from '../../../../../constants/Lookup';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

const BasicInfoRule = ({
  setTabValue,
  dataReset,
  rowSelected,
  setShowFilterData,
  StepperFilter,
  isCopy,
  fieldListCode,
  setRuleGroupCodeData,
  setValue,
  setBreCode,
  breCode,
  activeStep,
  setActiveStep,
  register,
  handleBack,
  handleNext,
  hideRule,
  setSelectedCategory,
  selectedCategory,
  hidden,
  setFieldListCode,
  setFieldList,
  stepSuccessMessage,
  setStepSuccessMessage,
  steps,
  roleData,
  roleDataAccessDc,
  editExisting,
  handleDirty,
}) => {
  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
    dispatch(fetchAllCodeAndDisplayName());
    setFieldList();
    setFieldListCode();
  }, []);

  const {baseCategoryData, dropDownData} = useSelector(({addFieldList}) => addFieldList);
  const {ruleGroupData, id} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    isLoading,
    successMsg,
    errorMsg,
    statusCode,
    allCodeAndDisplayName,
    basicInfoData,
    isFormulaRuleLoading,
    addRuleData,
    addRuleStatus,
    userMetrix,
    printStatus,
    downloadSuccessMessage,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  // const [selectedFieldList, setSelectedFieldList] = useState(null);
  const selectedFieldList = null;
  const [currentFormulaType, setCurrentFormulaType] = useState('');
  // const [deletedIds, setDeletedIds] = useState([]);
  const deletedIds = [];
  const [codePopover, setCodePopover] = useState(false);
  const [formulaCodesData, setFormulaCodesData] = useState();
  const [dialogState, setDialogState] = useState(false);
  const [overRiding, setOverRiding] = useState({});
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const codeRef = useRef();
  const saveRef = useRef();

  const handleDialogState = () => {
    setDialogState(false);
  };

  const formulaTypeOptions = [
    {key: 'Create Constant', value: 'Create Constant'},
    {
      key: 'Calculate based on Data Repository Fields',
      value: 'Calculate based on Data Repository Fields',
    },
  ];

  const getCategoryObject = (value, data) => {
    let item = {};
    data &&
      data?.map((i) => {
        if (i?.categoryCode === value) {
          item = i;
        }
      });
    return item;
  };
  const getObjects = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option) {
          label = item;
        }
      });
    return label;
  };
  const getObject = (option, options) => {
    let obj = {};
    options &&
      options?.map((ele) => {
        if (option === ele.value) {
          obj = ele;
        }
      });
    return obj;
  };

  const getFormulaCodesData = () => {
    if (allCodeAndDisplayName && allCodeAndDisplayName?.length > 0) {
      return allCodeAndDisplayName?.filter(
        (i) => String(i?.code?.toUpperCase())?.startsWith(formulaCodesData?.toUpperCase()) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  const initialValues = {
    code: basicInfoData?.code ? basicInfoData?.code : '',
    description: basicInfoData?.description ? basicInfoData?.description : '',
    // displayName: basicInfoData?.displayName ? basicInfoData?.displayName : "",
    returnType: basicInfoData?.returnType ?
      getObjects(basicInfoData?.returnType, RETURN_TYPE, dropDownData) :
      '',
    category: basicInfoData?.category ?
      getCategoryObject(basicInfoData?.category, baseCategoryData) :
      '',
    formulaType: basicInfoData?.formulaType ?
      getObject(basicInfoData?.formulaType, formulaTypeOptions) :
      '',
  };
  const checkCodeExist = (value) => {
    if (allCodeAndDisplayName && allCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allCodeAndDisplayName.filter((i) => {
        if (
          i?.code?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (allCodeAndDisplayName && allCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allCodeAndDisplayName.filter((i) => {
        if (
          i?.code?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (basicInfoData?.formulaType) {
      setCurrentFormulaType(basicInfoData?.formulaType);
    }
    if (basicInfoData?.formulaType === 'Create Constant') {
      hideRule(true);
    }
  }, [basicInfoData]);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMsg());
      }, 3000);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useEffect(() => {
    dispatch(resetFormula());
  }, []);

  useEffect(() => {
    if (statusCode === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        if (currentFormulaType === 'Create Constant') {
          !saveRef.current && setActiveStep(2);
          hideRule(true);
          setFieldListCode(null);
          setFieldList(null);
          // if (basicInfoData?.formulaType !== currentFormulaType) {
          //   basicInfoData?.addRule?.map((e) => {
          //     deletedIds.push(e?.ruleId);
          //   });
          // }
        } else if (currentFormulaType === 'Calculate based on Data Repository Fields') {
          hideRule(false);
          !saveRef.current && setActiveStep(1);
        } else {
          !saveRef.current && handleNext();
        }
      }, 2000);
    }
  }, [statusCode]);

  useEffect(() => {
    if (printStatus === 200) {
      setStepSuccessMessage(successMsg);
    } else if (successMsg) {
      setStepSuccessMessage(`${steps[0]} added/modified successfully`);
      setTimeout(() => {
        setStepSuccessMessage('');
      }, 1500);
    }
  }, [successMsg]);

  useEffect(() => {
    if (downloadSuccessMessage) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 1500);
    }
  }, [downloadSuccessMessage]);

  window.onclick = function() {
    setCodePopover(false);
  };

  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
      }, 2500);
    }
  }, [userMetrix, addRuleStatus]);

  useEffect(() => {
    setStepSuccessMessage('');
  }, []);

  useEffect(() => {
    dispatch(setReduxState({property: 'formData', value: {}}));
  }, []);

  useEffect(()=>{
    if (basicInfoData?.groupId || id) {
      dispatch(fetchRuleGroup(basicInfoData.groupId || id));
    }
  },[basicInfoData?.groupId,id])

  const handleSubmit = (values) => {
    const arr = [];
    const keys = Object.keys(initialValues);
    keys?.map((key) => {
      if (initialValues[key] !== values[key]) {
        console.log(initialValues[key], values[key], 'arr1');
        arr.push(key);
      }
    });

    if (values) {
      dispatch(submissionStart());
      const data = {
        addRule: basicInfoData?.addRule?.length > 0 ? basicInfoData?.addRule : [],
        deletedId: deletedIds?.length > 0 ? deletedIds : [],
        code: values?.code ? values?.code : '',
        description: values?.description ? values?.description : '',
        // displayName: values?.displayName ? values?.displayName : "",
        returnType: values?.returnType?.valueCode ? values?.returnType?.valueCode : '',
        groupId: basicInfoData?.groupId ? basicInfoData?.groupId : 0,
        result: basicInfoData?.result ? basicInfoData?.result : '',
        category:
          values?.formulaType?.value === 'Create Constant' ?
            '' :
            values?.category?.categoryCode ?
              values?.category?.categoryCode :
              '',
        isDraft: basicInfoData?.isDraft ? basicInfoData?.isDraft : 'Y',
        override: 'No',
        oldFormulaRuleGroupCode: '',
        formulaType: values?.formulaType?.value ? values?.formulaType?.value : '',
        overrideType: 'FORMULA',
      };
      dispatch(setReduxState({property: 'formData', value: data}));
      dispatch(setReduxState({property: 'category', value: data?.category}));
      setOverRiding(data);
      dispatch(postBasicInfo(data));
    }
  };

  const validationSchema = Yup.object().shape({
    code: !basicInfoData?.code ?
      Yup.string()
        .required('Data Calculation Name is required')
        .test('code', 'Data Calculation Name already exists', (value) => !checkCodeExist(value))
        .test(
          'code',
          'Data Calculation Name has already been used in the past',
          (value) => !checkCodeAlreadyExist(value),
        ) :
      null,
    // displayName: !basicInfoData?.displayName
    //   ? Yup.string()
    //       .required("Data Calculation Name is required")
    //       .test(
    //         "displayName",
    //         "Data Calculation Name already exist",
    //         (value) => !checkDisplayNameExist(value)
    //       )
    //   : null,
    description: Yup.string()
      .test('description', 'Data Calculation Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Data Calculation Description is required'),
    formulaType: Yup.mixed().test('formulaType', 'Data Calculation Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    category: Yup.mixed().test('category', 'Category is required', (value, context) => {
      if (
        context?.parent?.formulaType?.key === 'Calculate based on Data Repository Fields' &&
        !value
      ) {
        return false;
      } else {
        return true;
      }
    }),
    returnType: Yup.mixed().test('returnType', 'Return Type is required', (value) => {
      if (!value) {
        return false;
      } else {
        return true;
      }
    }),
  });

  const disableOnEdit = basicInfoData?.code;
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            errors,
            touched,
            dirty,
            handleBlur,
            handleChange,
            handleSubmit,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row new-standard-textfields  standard-field-textfields mt-2">
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    placeholder="Enter Data Calculation Name"
                    margin="dense"
                    name="code"
                    variant="outlined"
                    value={values.code}
                    label="Data Calculation Name"
                    inputRef={codeRef}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    inputProps={{maxLength: 25}}
                    disabled={disableOnEdit}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('code', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setFormulaCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    touched={touched.code}
                    required
                    error={Boolean(errors.code && touched.code)}
                    fullWidth
                  />
                  <FormHelperText variant="outlined" style={{position: 'relative'}}>
                    {touched.code && errors.code}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getFormulaCodesData()?.map((data) => (
                        <MenuItem key={data?.code}>{data?.code?.replace(/ /g, '\u00a0')}</MenuItem>
                      ))}
                  </div>
                </div>
                {/* <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter Data Calculation Name"
                    margin="dense"
                    name="displayName"
                    variant="outlined"
                    value={values.displayName}
                    label="Data Calculation Name"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("displayName", e.target.value);
                      if (e.target.value) {
                        setNamePopover(true);
                        setFormulaNamesData(e.target.value);
                      } else if (e.target.value === "") {
                        setNamePopover(false);
                      }
                    }}
                    disabled={basicInfoData?.displayName}
                    touched={touched.displayName}
                    required
                    error={Boolean(errors.displayName && touched.displayName)}
                    fullWidth
                  />
                  <FormHelperText variant="outlined">
                    {touched.displayName && errors.displayName}
                  </FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {namePopover &&
                      getFormulaNamesData()?.map((data) => (
                        <MenuItem key={data?.displayName}>{data?.displayName}</MenuItem>
                      ))}
                  </div>
                </div> */}
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    placeholder="Enter Data Calculation Description"
                    margin="dense"
                    name="description"
                    variant="outlined"
                    value={values.description}
                    label="Data Calculation Description"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    inputProps={{maxLength: 100}}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('description', e.target.value);
                    }}
                    touched={touched.description}
                    required
                    error={Boolean(errors.description && touched.description)}
                    fullWidth
                  />
                  <FormHelperText variant="outlined">
                    {touched.description && errors.description}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="formulaType"
                    id="formulaType"
                    size="small"
                    value={values.formulaType}
                    disabled={disableOnEdit}
                    options={formulaTypeOptions}
                    getOptionLabel={(option) => {
                      return option && option.value ? option?.value : '';
                    }}
                    onChange={(e, value) => {
                      hideRule(value?.key === 'Create Constant');
                      handleChange(e);
                      setFieldValue('formulaType', value);
                      setCurrentFormulaType(value?.value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          error={Boolean(touched.formulaType && errors.formulaType)}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Data Calculation Type"
                          required
                          className={` ${classes.labelName}`}
                          placeholder="Select Data Calculation Type"
                        />
                        <FormHelperText variant="outlined">
                          {touched.formulaType && errors.formulaType}
                        </FormHelperText>
                      </div>
                    )}
                  />
                </div>
                {values?.formulaType?.key === 'Calculate based on Data Repository Fields' ? (
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3  form-group">
                    <FormControl variant="outlined" fullWidth>
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        id="category"
                        value={values?.category}
                        disabled={values?.formulaType?.key === 'Create Constant' || disableOnEdit}
                        options={baseCategoryData?.length > 0 ? baseCategoryData : []}
                        size="small"
                        autoHighlight
                        getOptionDisabled={(option) => option?.categoryCode === null}
                        getOptionLabel={(option) => {
                          return option && option?.categoryName ?
                            option?.categoryCode === null ?
                              option?.categoryName :
                              option?.categoryCode + ' - ' + option?.categoryName :
                            '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            {...params}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            label="Category"
                            name="category"
                            required
                            placeholder="Select Category"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                            touched={touched.category}
                            error={Boolean(touched.category && errors.category)}
                          />
                        )}
                        onChange={(e, data) => {
                          handleChange(e);
                          dispatch(
                            setReduxState({property: 'category', value: data?.categoryCode}),
                          );
                          // props.onChange(data);
                          setFieldValue('category', data);
                          // setSelectedBaseCategory(data?.categoryCode);
                        }}
                      />
                      {/* )}
                      name="category"
                      control={control} */}
                    </FormControl>
                    <FormHelperText style={{color: 'red'}} variant="outlined">
                      {touched.category && errors.category}
                    </FormHelperText>
                  </div>
                ) : (
                  ''
                )}
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="returnType"
                    id="returnType"
                    size="small"
                    value={values.returnType}
                    options={getOptions(RETURN_TYPE, dropDownData)}
                    getOptionLabel={(option) => {
                      return option && option?.valueCode ? option?.valueCode : '';
                    }}
                    disabled={disableOnEdit}
                    onChange={(_, data) => {
                      setFieldValue('returnType', data);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Return Type"
                          touched={touched.returnType}
                          error={Boolean(touched.returnType && errors.returnType)}
                          required
                          // className={` ${classes.labelName} ${classes.selectLabel}`}
                          placeholder="Select Return Type"
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.returnType && errors.returnType}
                        </FormHelperText>
                      </div>
                    )}
                  />
                </div>
                {(selectedFieldList || ruleGroupData?.fieldListCode) && (
                  <div className="col-sm-6 col-md-3 col-lg-2 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Field List"
                      margin="dense"
                      name="fieldList"
                      variant="outlined"
                      label="Field List"
                      value={selectedFieldList}
                      defaultValue={initialValues.fieldList}
                      disabled
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      inputRef={register}
                      fullWidth
                    />
                  </div>
                )}
              </div>
              <div className="new-standard-textfields d-flex justify-content-center align-items-center disabled-button">
                <Button
                  variant="outlined"
                  disabled
                  onClick={handleBack}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={
                    (!roleDataAccessDc?.edit && basicInfoData?.code && editExisting) ||
                    enabledSubmission
                  }
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={
                    (!roleDataAccessDc?.edit && basicInfoData?.code && editExisting) ||
                    enabledSubmission
                  }
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      <OverrideRule
        dialogTitle="Override Data Calculation"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title={`This Data Calculation has been used in the following places.`}
        data={addRuleData}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(postBasicInfo({...overRiding, override: 'Yes'}));
          handleDialogState();
        }}
      />
      {(isLoading || isFormulaRuleLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(stepSuccessMessage || downloadSuccessMessage || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            stepSuccessMessage ?
              stepSuccessMessage :
              printUsageSuccessMsg ?
                printUsageSuccessMsg :
                downloadSuccessMessage
          }
        />
      )}
    </>
  );
};

export default BasicInfoRule;
